export const getFullName = (firstName?: string, lastName?: string): string => {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim()
}

export const getCityWithZip = (zip?: string, city?: string): string | undefined => {
  if (zip && city) {
    return `${zip} ${city}`
  }

  return zip || city
}

export const cleanText = (text: string): string => {
  return text.replaceAll(/[\u200B\u200C\uFEFF]/g, '')
}
